import { TreeNode } from 'primeng/api';

import { DocumentFile } from '@shared/models';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function blobFile(data: any, fileName: string): void {
  const a = document.createElement('a');
  document.body.appendChild(a);
  // tslint:disable-next-line:one-variable-per-declaration
  const blob = new Blob([data]),
    url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function downloadFileFromUrl(fileUrl: string, fileName: string): void {
  const a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function selectFile(accept: string, onSelect: (file: File) => void): void {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;

  input.onchange = () => {
    const file = input.files?.[0];
    if (file) {
      onSelect(file);
    }
  };

  input.click();
}

export function getFileExtension(filename: string): string {
  const lastDot = filename.lastIndexOf('.');

  if (lastDot <= 0 || lastDot === filename.length - 1) return '';

  return lastDot !== -1 ? filename.substring(lastDot) : '';
}

export function formatFileSize(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;

  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileIconClass(contentType?: string | null, fileName?: string | null): string {
  const normalizedContentType = contentType?.toLowerCase() ?? '';
  const normalizedFileName = fileName?.toLowerCase() ?? '';

  switch (true) {
    case normalizedContentType.includes('pdf') || normalizedFileName.endsWith('.pdf'):
      return 'pi-file-pdf';
    case normalizedContentType.includes('spreadsheet') ||
      normalizedContentType.includes('excel') ||
      normalizedContentType.includes('csv') ||
      normalizedFileName.match(/\.(csv|xls|xlsx)$/) !== null:
      return 'pi-file-excel';
    case normalizedContentType.includes('word') || normalizedFileName.match(/\.(doc|docx)$/) !== null:
      return 'pi-file-word';
    case normalizedContentType.includes('zip') ||
      normalizedContentType.includes('rar') ||
      normalizedFileName.match(/\.(7z|rar|zip)$/) !== null:
      return 'pi-folder';
    case normalizedContentType.includes('text') || normalizedFileName.endsWith('.txt'):
      return 'pi-file';
    case normalizedContentType.includes('image') ||
      normalizedFileName.match(/\.(apng|avif|gif|jpe?g|png|svg|webp)$/) !== null:
      return 'pi-image';
    default:
      return 'pi-file';
  }
}

export function buildFolderTreeFromFiles(files: DocumentFile[]): TreeNode[] {
  const rootNodes: TreeNode[] = [];

  files.forEach((file) => {
    let nodes = rootNodes;
    let currentPath = '';

    file.path
      ?.split('/')
      .map((folderName) => folderName.trim())
      .filter(Boolean)
      .forEach((folderName) => {
        currentPath = currentPath ? `${currentPath}/${folderName}` : folderName;

        let node = nodes.find((item) => item.label === folderName);

        if (!node) {
          node = {
            key: currentPath,
            label: folderName,
            children: [],
            expanded: true,
            icon: 'pi pi-folder',
          };
          nodes.push(node);
        }

        node.children ??= [];
        nodes = node.children;
      });
  });

  return rootNodes;
}
